import React from 'react'
import { Routes, Route } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import AdminRoute from './AdminRoute'

// Layouts
import AppLayout from '../components/layout/AppLayout'
import PublicLayout from '../components/layout/PublicLayout'
import DashboardLayout from '../components/layout/DashboardLayout'
import AuthLayout from '../components/layout/AuthLayout'

// Public pages
import HomePage from '../modules/home/pages/HomePage'
import PricingPage from '../modules/home/pages/PricingPage'
import TemplatesPage from '../modules/home/pages/TemplatesPage'
import NFCPage from '../modules/home/pages/NFCPage'

// Auth pages
import LoginPage from '../modules/auth/pages/LoginPage'
import RegisterPage from '../modules/auth/pages/RegisterPage'
import PendingPage from '../modules/auth/pages/PendingPage'

// User dashboard pages (existing)
import Dashboard from '../modules/dashboard/pages/Dashboard'
import VCardListPage from '../modules/vcards/pages/VCardListPage'
import VCardEditorPage from '../modules/vcards/pages/VCardEditorPage'
import SettingsPage from '../modules/settings/pages/SettingsPage'

// Public vCard view (existing)
import PublicVCardPage from '../modules/vcards/pages/PublicVCardPage'
const publicPrefix = (import.meta.env.VITE_PUBLIC_SLUG_PREFIX || '').trim()
const publicPath = `${publicPrefix ? `${publicPrefix}/:slug` : ':slug'}`

// Admin pages (only existing)
import AdminDashboard from '../modules/admin/pages/AdminDashboard'
import SeedAdminPage from '../modules/admin/pages/SeedAdminPage'

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<AppLayout />}>
        <Route index element={<HomePage />} />
        <Route path="templates" element={<TemplatesPage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="nfc" element={<NFCPage />} />
        
        {/* Auth routes */}
        <Route path="auth" element={<AuthLayout />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="pending" element={<PendingPage />} />
        </Route>
        
        {/* Seed admin (dev utility) */}
        <Route path="seed-admin" element={<SeedAdminPage />} />
      
      </Route>

      {/* Public Dkard minimal layout */}
      <Route path="/" element={<PublicLayout />}>
        <Route path={publicPath} element={<PublicVCardPage />} />
        {/* Redirect for slugs without prefix - handles direct slug access */}
        <Route path=":slug" element={<PublicVCardPage />} />
      </Route>

      {/* Protected user routes */}
      <Route path="/" element={<PrivateRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="editor" element={<VCardListPage />} />
          <Route path="editor/:id" element={<VCardEditorPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Route>

      {/* Protected admin routes */}
      <Route path="/" element={<AdminRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="admin" element={<AdminDashboard />} />
          <Route path="admin/users" element={<AdminDashboard />} />
          <Route path="admin/vcards" element={<AdminDashboard />} />
          <Route path="admin/plans" element={<AdminDashboard />} />
          <Route path="admin/contacts" element={<AdminDashboard />} />
          <Route path="admin/templates" element={<AdminDashboard />} />
        </Route>
      </Route>

      {/* Catch all route */}
      <Route path="*" element={<div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <p className="text-xl text-gray-600 mb-8">Página no encontrada</p>
          <a href="/" className="btn-primary">
            Volver al inicio
          </a>
        </div>
      </div>} />
    </Routes>
  )
}

export default AppRoutes
